import React from 'react'
import style from "./AccusationCase.module.css";

const Personal = ({index, key_name, handleInput, data, tab, consult, showFiles, getShowFiles,setSubmitStatus,onChangeInput}) => {
    return (

        <div className={style.add_txt}>
            <div className={style.item_input_text}>
                <p className={style.tit}>성명</p>
                <input type="text" name={`${key_name}_date`} data-index={index} placeholder='' value={data?.date} onChange={handleInput}/>
            </div>

            <div className={style.item_input_text}>
                <p className={style.tit}>주민등록번호</p>
                <input type="text" name={`${key_name}_agency`} data-index={index} placeholder='' value={data?.agency} onChange={handleInput}/>
            </div>

            <div className={style.item_input_text}>
                <p className={style.tit}>주소</p>
                <input type="text" name={`${key_name}_add`} data-index={index} placeholder='' value={data?.add} onChange={handleInput}/>
            </div>

            <div className={style.item_input_text}>
                <p className={style.tit}>직업</p>
                <input type="text" name={`${key_name}_job`} data-index={index} placeholder='' value={data?.job} onChange={handleInput}/>
            </div>
            <div className={style.item_input_text}>
                <p className={style.tit}>전화</p>
                <input type="text" name={`${key_name}_tel`} data-index={index} placeholder='' value={data?.tel} onChange={handleInput}/>
            </div>  <div className={style.item_input_text}>
            <p className={style.tit}>입증하려는 내용</p>
            <input type="text" name={`${key_name}_cont`} data-index={index} placeholder='' value={data?.cont} onChange={handleInput}/>
        </div>


            ※ 증거란에 각 증거물을 개별적으로 기재하고, 소유자란에는 고소장 제출시 누가 소유하고 있는지, 제출 유무란에는 고소장 접수시 제출하는지 또는 수사 중 제출할 예정인지 표시하시기 바랍니다.
        </div>

    )
}

export default Personal
